const lockedCampaigns = ['OptInRequest', 'MissingDetailReminder1', 'BookingUpdated']

export default lockedCampaigns
